import React from 'react'
import './footer.css'

function Footer() {
  return (
   <>
   <br/>
   <br/>
   <br/>
   <br/>
    <hr />
    <div className='main-container'>
        <div className='class-container'>
            <h2 className='title-footer'>Location</h2>
            <p className='last-p'><strong>Dietition Clinic <br /> Ventu Life Center <br /> ANFARA Clinic <br /></strong><em>Email:</em> Sarahnutre@gmail.com <br /> <em>Phone:</em>
          (832)740-7948</p>
        </div>
        <div className='class-container'>
            <h2 className='title-footer2'>More Links</h2>
            <br />
            <a href='https://www.facebook.com/sarahfloresnutricion' target="blank" className='links'><i className="fa-brands fa-facebook"></i></a>
            <a href='https://www.instagram.com/sarahfloresnutricion/' target="blank" className='links'><i class="fa-brands fa-instagram-square"></i></a>
        </div>
        <div className='class-container'>
                <img src='./images/certified.jpg' alt='certified' />
        </div>
    </div>
    </>
  )
}

export default Footer